const path = 'DashboardsModule';
const apiPath = 'customs/dashboard';

const DashboardModelActions = {
    //action type
    GET_DATA : `${path}/getStatisticData`,
};

const DashboardModelAPIsConstants = {
    API_PATH : `${apiPath}`
}

export {DashboardModelActions, DashboardModelAPIsConstants};
